var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-input-radio radio"},[_c('input',{attrs:{"id":_vm.id,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_c('label',{class:{
      'radio-label': true,
      'base-input-radio__disabled': _vm.disabled,
      'base-input-radio__checked': _vm.checked,
    },attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }